import { render } from "./SiteMediaAttachModal.vue?vue&type=template&id=b7b2d912"
import script from "./SiteMediaAttachModal.vue?vue&type=script&lang=js"
export * from "./SiteMediaAttachModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__